import React, { useEffect } from "react";
import "./bookinghome.css";
import { motion } from "framer-motion";
import Aos from "aos";
import "aos/dist/aos.css";
import { useLocation } from "react-router-dom";

const BookingHome = () => {
  const location = useLocation();
  const { tourTitle, images } = location.state || {};

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  // ✅ تحديد الصورة الأولى من مصفوفة الصور
  const firstImage = images?.length
    ? `https://admin.mythsegypttours.com/storage/${images[0]}`
    : "/fallback-image.jpg"; // صورة بديلة في حالة عدم وجود صور

  return (
    <section className="home">
      {/* الخلفية */}
      <img
        src={firstImage}
        alt={tourTitle || "Egypt Tours"}
        className="backgroundImg"
      />

      {/* Overlay */}
      <div className="overlay"></div>

      {/* المحتوى */}
      <div className="homeContent">
        <h1 className="mainTitle" data-aos="fade-down">
          {tourTitle || "Selected Tour"}
        </h1>
      </div>
    </section>
  );
};

export default BookingHome;
